<template lang="pug">
table.quote-comparation
  tr
    th.no-border
    template(v-for="quote in value")
      template(v-if="isNotDeleted(quote)")
        template(v-if="isSelected(quote)")
          th.pt-2.selected
            div.d-flex
              v-spacer
              span.mb-1.mr-1.pa-1.primary.white--text.recommended {{$t('Quote.selectedQuote')}}
            div {{ getQuoteCarrier(quote) }}
        th.pt-3(v-else) {{ getQuoteCarrier(quote) }}
  template(v-for="field in fields")
    tr
      td {{ getLabel(field) }}
      template(v-for="quote in value")
        template(v-if="isNotDeleted(quote)")
          template(v-if="field.name === 'quoteTotal'")
            td(:class="{ selected: isSelected(quote) }") {{ getQuoteTotal(quote) }}
          td(v-else :class="{ selected: isSelected(quote) }") {{ transformValues(field, quote[field.name]) }}
  template(v-if="hasQuoteItems")
    tr
      td.spaced
      template(v-for="quote in value")
        template(v-if="isNotDeleted(quote)")
          td.spaced(:class="{ selected: isSelected(quote) }")
    tr(v-for="serviceItem in quoteItemsServiceItems")
      td {{ serviceItem }}
      template(v-for="quote in value")
        template(v-if="isNotDeleted(quote)")
          td(:class="{ selected: isSelected(quote) }") {{ getRate(quote, serviceItem) }}
  template(v-for="group in extraFieldGroups")
    tr
      td.spaced
      template(v-for="quote in value")
        template(v-if="isNotDeleted(quote)")
          td.spaced(:class="{ selected: isSelected(quote) }")
    tr(v-for="field in group.fields")
      td {{ getLabel(field) }}
      template(v-for="quote in value")
        template(v-if="isNotDeleted(quote)")
          td(:class="{ selected: isSelected(quote) }") {{ getValue(quote, field) }}
</template>

<style lang="scss" scoped>
.quote-comparation {
  text-align: right;
  vertical-align: bottom;
  border-spacing: 20px 0;

  th, td {
    padding: 4px;
    border: 1px solid black;
    border-bottom: 0;
    min-width: 200px;
    max-width: 200px;

    &.selected {
      border-color: white;
      background: rgba(50, 0, 230, 0.1);
      .recommended {
        font-size: 9px;
        text-align: right;
        border: 1px solid rgb(135, 135, 139);
        line-height: 9px;
      }
      &.spaced {
        background: none;
      }
    }

    &.spaced {
      border-left: 0;
      border-right: 0;
    }
  }

  td:first-child {
    text-align: left;
    position: sticky;
    left: 0;
    background-color: white;
  }

  th {
    vertical-align: bottom;
    font-size: 18px;
    color: black;

    &.no-border {
      border: none;
    }
  }

  tr:last-child {
    td {
      border-bottom: 1px solid black;
      &.selected {
        border-color: white;
      }
    }
  }
}
</style>

<script>
import EntityMixin from '@/mixins';
import moment from 'moment';

export default {
  mixins: [EntityMixin],
  props: {
    carriers: {
      type: Array,
      default: () => ([]),
    },
    entity: null,
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    key: 0,
  }),
  methods: {
    getQuoteTotal({ quoteItems = [], currency }) {
      let grandT = 0;
      for(var i=0; quoteItems && i < quoteItems.length; i++)
      {
          grandT = grandT + Number(quoteItems[i].subtotalBuy);
      }

      const quoteTotal = Number(grandT).toFixed(2);
      const formatted = `${quoteTotal} ${currency || ""}`;
      return formatted;
    },
    getQuoteCarrier({ carrierId }) {
      if (!carrierId) return 'N/A';
      const { name } = this.carriers.find(carrier => Number(carrier.id) === Number(carrierId)) || {};
      return name || 'N/A';
    },
    findVisibleIndex(element) {
      if (!this.visibleElements) return null;
      return this.visibleElements.findIndex(vp => {
        if (element && element.id) return vp.id === element.id
        if (element && element.__id) return vp.__id === element.__id
      });
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    isSelected({ recommended }) {
      return recommended;
    },
    getLabel({ label, name }) {
      return this.$camelToString(label || name);
    },
    getValue({ extraData = [] }, field) {
      const { value } = this.getExtraData(extraData, field);
      return this.transformValues(field, value) || null;
    },
    getExtraData(extraData, field) {
      return extraData.find(e => Number(e.extraFieldId) === Number(field.extraFieldId)) || {};
    },
    transformValues({ type }, value) {
      if (!value) return null;
      if (type === 'DateTime') return moment(value).format('DD-MMM-YYYY HH:mm')
      return value;
    },
    getRate({ quoteItems = [] }, serviceItem ) {
      const { buy } = quoteItems.find(qI => qI.serviceItem === serviceItem) || {};
      return buy;
    },
  },
  computed: {
    extraFieldGroups() {
      return _.get(this.entity, 'fields', []).filter(f => f.extra && (!f.section || f.section === this.entityName) );
    },
    visibleElements() {
      return (this.value || []).filter(this.isNotDeleted);
    },
    allQuoteItems() {
      return _.flatMap(this.value, 'quoteItems');
    },
    uniqQuoteItems() {
      return _.uniqBy(this.allQuoteItems, 'serviceItem');
    },
    quoteItemsServiceItems() {
      return _.map(this.uniqQuoteItems, 'serviceItem');
    },
    hasQuoteItems() {
      return !_.isEmpty(this.allQuoteItems);
    },
  }
}
</script>
